export default __webpack_public_path__ + "static/media/20170618_002153.7ccdfca7.jpg";